import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileHd"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V18C1.5 18.8284 2.17157 19.5 3 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V6C22.5 5.17157 21.8284 4.5 21 4.5ZM9.75 11.25V8.25H11.25V15.75H9.75V12.75H7.5V15.75H6V8.25H7.5V11.25H9.75ZM16.5 8.25H13.5V15.75H16.5C17.7426 15.75 18.75 14.7426 18.75 13.5V10.5C18.75 9.25736 17.7426 8.25 16.5 8.25ZM17.25 13.5C17.25 13.9142 16.9142 14.25 16.5 14.25H15V9.75H16.5C16.9142 9.75 17.25 10.0858 17.25 10.5V13.5ZM3 6V18H21V6H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileHd.vue"]]);
